import React from 'react'

export default function Vpc() {
  return (
    <div>Vpc</div>
  )
}
